module.exports = __webpack_public_path__ + "static/media/scratch.4ab4aaf3.svg";